import '../../css/topbar.css';
import Logo from '../../images/logo.png';
import { Link } from "react-router-dom";
import { Icon } from '../../icons/AppIcons';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import API from '../../api/api';

const FireApi = new API();

function lampClass(ok) {
  if (ok === true) return 'is-ok';
  if (ok === false) return 'is-bad';
  return 'is-off';
}

function lampLabel(ok) {
  if (ok === true) return 'OK';
  if (ok === false) return 'Störung';
  return '–';
}

function formatAge(seconds) {
  if (seconds === null || seconds === undefined) return '–';
  const s = Math.max(0, Math.floor(seconds));
  if (s < 5) return 'jetzt';
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h`;
}

function TopBar() {
  const { darkMode, toggleTheme } = useTheme();
  const [live, setLive] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const tick = () => {
      FireApi.endpoints.live.get()
        .then((res) => {
          if (!cancelled && res?.data) setLive(res.data);
        })
        .catch(() => {
          if (!cancelled) {
            setLive({ mqtt_process: false, mqtt_broker: false, devices_online: 0, devices_total: 0, devices: [] });
          }
        });
    };
    tick();
    const id = setInterval(tick, 4000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const processOk = live ? Boolean(live.mqtt_process) : null;
  const brokerOk = live ? Boolean(live.mqtt_broker) : null;
  const online = live?.devices_online ?? 0;
  const total = live?.devices_total ?? 0;
  const devicesOk = total === 0 ? null : online === total;
  const devices = Array.isArray(live?.devices) ? live.devices : [];
  const processValue = processOk === true
    ? `OK · ${formatAge(live?.process_age)}`
    : lampLabel(processOk);

  return (
    <div className="top-bar">
      <div className="top-bar-logo-container">
        <Link to="/">
          <img className="top-bar-logo" src={Logo} alt="FireCore" />
        </Link>
      </div>
      <div className="top-bar-ampel">
        <div className="top-bar-ampel-group">
          <span className={`top-bar-lamp ${lampClass(processOk)}`}>
            <span className="top-bar-lamp-dot" />
            Dienst
          </span>
          <span className={`top-bar-lamp ${lampClass(brokerOk)}`}>
            <span className="top-bar-lamp-dot" />
            Broker
          </span>
          <span className={`top-bar-lamp ${lampClass(devicesOk)}`}>
            <span className="top-bar-lamp-dot" />
            {live ? `${online}/${total}` : '–'}
          </span>
          <div className="top-bar-ampel-panel">
            <div className="top-bar-ampel-row">
              <span>Dienst</span>
              <strong className={lampClass(processOk)}>{processValue}</strong>
            </div>
            <div className="top-bar-ampel-row">
              <span>Broker</span>
              <strong className={lampClass(brokerOk)}>{lampLabel(brokerOk)}</strong>
            </div>
            <div className="top-bar-ampel-row">
              <span>Alarme</span>
              <strong className={(live?.open_alarms || 0) > 0 ? 'is-bad' : 'is-ok'}>
                {live?.open_alarms ?? '–'}
              </strong>
            </div>
            <div className="top-bar-ampel-row">
              <span>Koffer</span>
              <strong className={lampClass(devicesOk)}>{live ? `${online}/${total}` : '–'}</strong>
            </div>
            {devices.length > 0 && (
              <div className="top-bar-ampel-devices">
                {devices.map((device) => (
                  <Link
                    key={device.id}
                    to={`/devices/${device.id}/`}
                    className={`top-bar-ampel-device ${device.online ? 'is-ok' : 'is-bad'}`}
                  >
                    <span className={`top-bar-lamp-dot ${device.online ? 'is-ok' : 'is-bad'}`} />
                    <span className="top-bar-ampel-device-name">{device.name}</span>
                    <span>{formatAge(device.age)}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="top-bar-actions">
        <IconButton onClick={toggleTheme} aria-label="Theme umschalten">
          {darkMode ? <Icon name="light" size={26} /> : <Icon name="dark" size={26} />}
        </IconButton>
        <Link to="/auth/logout/">
          <IconButton aria-label="Abmelden">
            <Icon name="logout" size={26} />
          </IconButton>
        </Link>
      </div>
    </div>
  );
}

export default TopBar;
